import { DiagnosticCode } from '../../../../DiagnosticCode';
import { DiagnosticMessage } from '../../../../DiagnosticMessage';
import { BuiltinMemberCall } from '../../BuiltinMemberCall';
export class PublicKeyFrom extends BuiltinMemberCall {
    emitCall(sb, _func, node, options) {
        const address = sb.context.analysis.extractLiteralPublicKey(node);
        if (address === undefined) {
            sb.context.reportError(node, DiagnosticCode.InvalidLiteral, DiagnosticMessage.InvalidPublicKey);
            return;
        }
        sb.emitPushBuffer(node, address);
        sb.emitHelper(node, options, sb.helpers.wrapBuffer);
    }
}

//# sourceMappingURL=from.js.map
